module.exports = "/_next/static/images/verificationFailed-4066b18ba0cbadaf46140caa3c2dbd6a.svg";